import { useState, useEffect, useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Guest from '../Asset/image/blank_profile.png';
import Setting from '../Asset/image/edit_pencil.png';
import Gender from '../Asset/image/gender.png';
import Phone from '../Asset/image/phone.png';
import UserInput from '../Asset/image/user_input.png';
import Mail from '../Asset/image/email.png';
import Modal from 'react-bootstrap/Modal';
import CustomImage from './CustomImage';
import { toast } from 'react-toastify';
import { useAuth } from '../Context/AuthProvider';
import { getUserDetailService, updateProfileService } from '../services/userService';
import { changeProfilePictureService, uploadFileType } from '../services/fileUploadService';
import { useSelector } from 'react-redux';
import { loginItemsSelector } from '../redux/slices/login';
import { isEmpty, validatePhoneNumber } from '../data/constants';
import DateInput from './DateInput';
import ApiConfig from '../config/ApiConfig';
import { genderDefault } from '../lib/helper';

function ProfileSettingsModal({ show, setShow }) {
    const { updateUserProfile } = useAuth()
    const { user } = useSelector(loginItemsSelector);
    const [validated, setValidated] = useState(false);
    const [isLoading, setLoader] = useState(false);
    const [state, setState] = useState({
        name: user?.userDetails?.name,
        email: user?.userDetails?.email,
        // token:userDetail?.userToken,
        dob: user?.userDetails?.dob,
        gender: user?.userDetails?.gender,
        phone: user?.userDetails?.mobileNo,
        image: ApiConfig.BASE_IMAGE_URL + user?.userDetails?.profilePicture + ".jpg" + "?" + new Date().getTime(),
    });
    const [error, setError] = useState({});
    const renderError = (msg, value, style) => {
        return (
            value ? (
                <h6 className="blog_error_text4 signUpMsg12 mt-2" style={{ marginBottom: 10, marginTop: style !== undefined ? 10 : -10 }}>
                    {msg}
                </h6>) : null)
    }
    useEffect(() => {
        if (user?.userDetails?.profilePicture) {
            setState({ ...state, image: ApiConfig.BASE_IMAGE_URL + user?.userDetails?.profilePicture + ".jpg" + "?" + new Date().getTime() });
        }
        else {
            setState({ ...state, image: "" })
        }
    }, [user])
    const getDate = (date) => {
        try {
            if (date && new Date(date) != 'Invalid Date') {
                return new Date(date)
            }
            // return new Date(date)
        } catch (error) {
            console.log('error', error)
        }
    }

    const updateProfile = async (imageId) => {
        try {
            setLoader(true)
            const params = {
                "name": state.name,
                "mobileNo": state.phone,
                "gender": state.gender,
                "dob": state.dob,
                "profilePicture": imageId,
            };
            const response = await updateProfileService(params);
            if (response.data) {
                updateUserProfile();
                setLoader(false);
                toast.success(response?.data);
                handleClose();
            }
        } catch (err) {
            console.log(err)
            setLoader(false)
        }
    };

    const onImageSelect = (imageData) => {
        setState({ ...state, image: imageData })
        changeProfilePicture(imageData);
        setLoader(true)
    };

    const changeProfilePicture = async (imageData) => {
        try {
            const response = await changeProfilePictureService(
                imageData,
                uploadFileType.avatar,
            );
            if (response) {
                updateProfile(user?.userDetails?._id);

            }
        } catch (err) {
            console.log(err);
        }
    };
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === false) {
            setValidated(false);
        } else {
            updateProfile(user._id);
        }
        setValidated(true);
    };
    const onRemoveProfile = () => {
        updateProfile('');
    };
    const handleClose = () => setShow(false);
    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header className="border-0 " closeButton>
                    <Modal.Title id="contained-modal-title-vcenter"> <h5 className='mb-0'>Profile Settings</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBody border-0 mb-4">
                    <div className='position-relative my-2 mb-1' style={{ display: "flex", justifyContent: "center" }}>
                        <CustomImage style={{
                            height: "100px",
                            borderRadius: "50%",
                            width: "100px",
                            objectFit: "cover",
                        }} src={state.image && typeof state?.image == 'object' ? URL.createObjectURL(state.image) : state?.image ? state.image : Guest} />
                        <input
                            id="fileInput" type="file"
                            accept="image/*"
                            onChange={(e) => {
                                onImageSelect(e.target.files[0]);
                            }}
                        />
                        <label for="fileInput">
                            <CustomImage src={Setting} style={{
                                width: 'auto',
                                height: '25px',
                                marginLeft: "-20px",
                                borderRadius: 10,
                                backgroundColor: "white",
                                position: 'absolute',
                                bottom: 5,
                            }} />
                        </label>
                    </div>
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Row>

                            <Form.Group className="col-md-6" controlId="exampleForm.ControlInput1">
                                <div className="wrapper w-100">
                                    <CustomImage className="profileIcon" src={UserInput} />
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="John Doe"
                                        className="input-box px-5"
                                        value={state.name}
                                        onChange={(e) => { setState({ ...state, name: e.target.value }); setError({ ...error, name: false }) }}
                                        autoFocus
                                    />
                                    <Form.Control.Feedback type="invalid">Please enter name!</Form.Control.Feedback>
                                </div>
                            </Form.Group>

                            <Form.Group className="col-md-6" controlId="exampleForm.ControlInput2">
                                <div className="wrapper w-100">
                                    <CustomImage className="profileIcon" src={Mail} />
                                    <Form.Control
                                        type="email"
                                        placeholder="Email"
                                        className="input-box px-5"
                                        value={state.email}
                                        autoFocus
                                    />
                                    <Form.Control.Feedback type="invalid">Please enter email!</Form.Control.Feedback>
                                </div>
                            </Form.Group>
                            {/* </Row>
                        <Row> */}
                            <Form.Group className="col-md-6" controlId="exampleForm.ControlInput3">
                                <div className="wrapper w-100">
                                    <CustomImage className="profileIcon" src={Phone} />
                                    <Form.Control
                                        required
                                        type="number"
                                        placeholder="Phone Number"
                                        className="input-box px-5"
                                        value={state.phone}
                                        onChange={(e) => { setState({ ...state, phone: (e.target.value).slice(0, 10) }); setError({ ...error, phone: false }) }}
                                        autoFocus
                                    />
                                    <Form.Control.Feedback type="invalid">Please enter phone number!</Form.Control.Feedback>
                                </div>
                            </Form.Group>
                            <Form.Group className="col-md-6 custom_dateInput" controlId="exampleForm.ControlInput4">
                                <DateInput
                                    required
                                    value={getDate(state.dob)}
                                    maxDate={new Date()}
                                    inputClassName={"input-box px-1"}
                                    onChangeDate={(date) => { setState({ ...state, dob: date }); setError({ ...error, dob: false }) }} />
                                <Form.Control.Feedback type="invalid">Please enter date of birth!</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="col-md-6 ">
                                <div className="wrapper">
                                    <CustomImage className="profileIcon" src={Gender} />
                                    <Form.Select required className="input-box1 ps-5" value={state.gender} onChange={(e) => setState({ ...state, gender: e.target.value })} >
                                        {genderDefault?.map((item, index) =>
                                            <option key={index} >{item?.title}</option>
                                        )}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">Please select gender!</Form.Control.Feedback>
                                </div>
                            </Form.Group>


                            <Button type='submit' className='login_button mt-4 w-100' disabled={isLoading}
                            // onClick={handleClose}
                            >
                                {isLoading ? (
                                    <div className='d-flex justify-content-center'>
                                        <center>
                                            <div
                                                style={{ width: "1rem", height: "1rem", color: "#1f7e78" }}
                                                class="spinner-border me-2"
                                                role="status"
                                            />
                                        </center>Update
                                    </div>) : "Update"}
                            </Button>
                        </Row>

                    </Form>
                </Modal.Body>

            </Modal >
        </>
    );
}

export default ProfileSettingsModal;